const D = {
  ROOT: "ROOT",
  EDGE_POOL: "EDGE_POOL",
  EDGE: "EDGE",
  SITE: "SITE",
  RADIO_GROUP: "RADIO_GROUP",
  RADIO: "RADIO"
};
var G = /* @__PURE__ */ ((E) => (E.GREEN = "GREEN", E.YELLOW = "YELLOW", E.RED = "RED", E.ORANGE = "ORANGE", E.BLUE = "BLUE", E.GREY = "GREY", E.UNKNOWN = "UNKNOWN", E))(G || {});
export {
  G as COLOR,
  D as GRAPH_NODE_TYPES
};
